import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const apiSlice = createApi({
  reducerPath: "api",
  baseQuery: fetchBaseQuery({
    baseUrl: "http://localhost:9000",
  }),
  tagTypes: [],
  endpoints: (builder) => ({
    getTeams: builder.query({
      query: () => "/team",
    }),
    getProjects: builder.query({
      query: () => "/projects",
    }),
    getTasks: builder.query({
      query: () => "/tasks",
    }),
    getFiletTasks: builder.query({
      query: (url) => {
        const filterUrl =
          url !== "" ? `/tasks?${url}` : "/tasks?project.projectName";
        console.log(filterUrl);
        return filterUrl;
      },

      async onQueryStarted(arg, { dispatch, queryFulfilled }) {
        try {
          const { data: updateData } = await queryFulfilled;

          dispatch(
            apiSlice.util.updateQueryData("getTasks", undefined, (draft) => {
              draft.splice(0, draft?.length, ...updateData);
            })
          );
        } catch {}
      },
    }),
    getTask: builder.query({
      query: (id) => `/tasks/${id}`,
    }),
    addTask: builder.mutation({
      query: (data) => ({
        url: "/tasks",
        method: "POST",
        body: data,
      }),

      async onQueryStarted(arg, { dispatch, queryFulfilled }) {
        try {
          const { data: addData } = await queryFulfilled;

          dispatch(
            apiSlice.util.updateQueryData("getTasks", undefined, (draft) => {
              draft.push(addData);
            })
          );
        } catch {}
      },
    }),
    updateTask: builder.mutation({
      query: ({ id, data }) => ({
        url: `/tasks/${id}`,
        method: "PATCH",
        body: data,
      }),

      async onQueryStarted(arg, { dispatch, queryFulfilled }) {
        try {
          const { data: updateData } = await queryFulfilled;

          dispatch(
            apiSlice.util.updateQueryData("getTasks", undefined, (draft) => {
              const findTask = draft?.find((t) => t.id === arg.id);
              Object.assign(findTask, updateData);
            })
          );

          dispatch(
            apiSlice.util.updateQueryData(
              "getTask",
              arg?.id.toString(),
              (draft) => {
                Object.assign(draft, updateData);
              }
            )
          );
        } catch {}
      },
    }),
    updateTaskStatus: builder.mutation({
      query: ({ id, data }) => ({
        url: `/tasks/${id}`,
        method: "PATCH",
        body: data,
      }),

      async onQueryStarted(arg, { dispatch, queryFulfilled }) {
        try {
          const { data: updateData } = await queryFulfilled;

          dispatch(
            apiSlice.util.updateQueryData("getTasks", undefined, (draft) => {
              const findTask = draft?.find((t) => t.id == arg.id);
              Object.assign(findTask, updateData);
            })
          );
        } catch {}
      },
    }),
    deleteTask: builder.mutation({
      query: (id) => ({
        url: `/tasks/${id}`,
        method: "DELETE",
      }),

      async onQueryStarted(arg, { dispatch, queryFulfilled }) {
        const removeTask = dispatch(
          apiSlice.util.updateQueryData("getTasks", undefined, (draft) => {
            return draft.filter((t) => t.id !== arg);
          })
        );
        try {
          await queryFulfilled;
        } catch {
          removeTask.undo();
        }
      },
    }),
  }),
});

export const {
  useGetTeamsQuery,
  useGetProjectsQuery,
  useGetTasksQuery,
  useUpdateTaskStatusMutation,
  useGetTaskQuery,
  useUpdateTaskMutation,
  useAddTaskMutation,
  useDeleteTaskMutation,
  useGetFiletTasksQuery,
} = apiSlice;
